"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendWithdrawalMail = exports.sendMail = exports.mailErrorText = void 0;
var use_messageData_1 = require("./use-messageData");
var vue_1 = require("vue");
var axios_1 = require("@ocm/axios");
var use_restrictions_1 = require("./use-restrictions");
var routeName_type_1 = require("@/types/routeName.type");
var router_1 = require("@/router");
var CONTACT_CENTER_MAIL_URL = "/rest/contactcenter/sendmail";
var CONTACT_CENTER_MAIL_WITH_ATTACHMENTS_URL = "/rest/contactcenter/sendmailwithattachments";
exports.mailErrorText = (0, vue_1.ref)("");
var sendMail = function (token) { return __awaiter(void 0, void 0, Promise, function () {
    var mailObject, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                exports.mailErrorText.value = "";
                return [4 /*yield*/, (0, use_messageData_1.returnEmailObject)()];
            case 1:
                mailObject = _a.sent();
                url = use_restrictions_1.authRequired.value ? CONTACT_CENTER_MAIL_WITH_ATTACHMENTS_URL : CONTACT_CENTER_MAIL_URL;
                return [4 /*yield*/, sendMailTo(mailObject, token, url)];
            case 2:
                _a.sent();
                if (exports.mailErrorText.value)
                    return [2 /*return*/];
                router_1.default.push({ name: routeName_type_1.THANK_YOU_PAGE_NAME });
                return [2 /*return*/];
        }
    });
}); };
exports.sendMail = sendMail;
var sendWithdrawalMail = function (token) { return __awaiter(void 0, void 0, Promise, function () {
    var mailObject;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                exports.mailErrorText.value = "";
                return [4 /*yield*/, (0, use_messageData_1.returnWithdrawalEmailObject)()];
            case 1:
                mailObject = _b.sent();
                return [4 /*yield*/, sendMailTo(mailObject, token, CONTACT_CENTER_MAIL_URL)];
            case 2:
                _b.sent();
                if (exports.mailErrorText.value)
                    return [2 /*return*/];
                router_1.default.push({
                    name: routeName_type_1.THANK_YOU_PAGE_NAME,
                    query: { flow: "withdrawal", orderNumber: String((_a = use_messageData_1.orderNumber.value) !== null && _a !== void 0 ? _a : "") },
                });
                return [2 /*return*/];
        }
    });
}); };
exports.sendWithdrawalMail = sendWithdrawalMail;
var sendMailTo = function (mailObject, token, url) { return __awaiter(void 0, void 0, Promise, function () {
    var json, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                json = JSON.stringify(__assign({}, mailObject));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.$axios.post(url, json, {
                        headers: {
                            "content-type": "application/json",
                            "g-recaptcha-response": token,
                        },
                    })];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                err_1 = _a.sent();
                exports.mailErrorText.value = "generalError";
                console.log(err_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
